var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99744 9.99658H9.00281L6.00546 15L2.99744 9.99658Z",
    fill: "#006EB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 9.99658H21.0028L18.0055 15L14.9974 9.99658Z",
    fill: "#00A2C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00513 15L9.00247 9.99658L11.9998 15H6.00513Z",
    fill: "#004588"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0053 15L21.0027 9.99658L24 15H18.0053Z",
    fill: "#009BC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00537 15L2.99735 9.99658L0 15H6.00537Z",
    fill: "#005DAC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00281 9.99601H2.99744L6.00546 4.99263L9.00281 9.99601Z",
    fill: "#009CE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15L14.9973 9.99658L18.0054 15H12Z",
    fill: "#0091BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00275 9.99658H14.9974L12.0001 15L9.00275 9.99658Z",
    fill: "#008AAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 9.99601L12.0001 4.99263L9.00275 9.99601H14.9974Z",
    fill: "#009DC8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0054 4.99263L14.9973 9.99601L12 4.99263H18.0054Z",
    fill: "#00AFD8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0028 9.99601H14.9974L18.0055 4.99263L21.0028 9.99601Z",
    fill: "#00B5DA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0054 4.9931L14.9974 -7.62939e-06L12 4.9931H18.0054Z",
    fill: "#21C1DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummitIcon);
export default __webpack_public_path__ + "static/media/summit-icon.c0f8a2a1e4a98d40ff1648707664b118.svg";
export { ForwardRef as ReactComponent };